import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import { Fade } from "react-awesome-reveal";

// Components
import DataTable from "../../../components/Datatable/DataTable";
import NoRecords from "../../../components/NoRecords/NoRecords";

import { getList } from '../../../store/ducks/instantRebate/actions';

class Rebate extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {

/*       const props = {
        member_id: this.props.member_id,
        merchant_id: this.props.merchant_id,
        country_id: this.props.country_id,
        start_date: this.props.start_date,
        end_date: this.props.end_date
      }; */

      //this.props.getList();

/*       if (this.props.setTotalRebate && this.props.totalRebate) {
        this.props.setTotalRebate(this.props.totalRebate);
      } */

      //this.props.getList();

    }

    componentDidUpdate(prevProps) {
      // When the list API finishes, totalRebate in Redux changes.
      if (prevProps.totalRebate !== this.props.totalRebate && this.props.setTotalRebate) {
        const amt = Number(this.props.totalRebate) || 0;
        this.props.setTotalRebate(amt);
      }
    }

    render() {

      const { t, totalRebate } = this.props;

      let rsData = (this.props.rows || []).map((item, index) => ({
        // important for `keyField="id"`
        update_date: item.update_date.replace(/\b\w/g, c => c.toUpperCase()),
        category: t(`game-type.${item.category}`),
        game_provider: t(`vendor.${item.gameVendorSlug}`),
        turnover: Number(item.turnover),           // ensure numeric
        rebate_rate: Number(item.rebate_rate),     // ensure numeric
        instant_rebate: Number(item.instant_rebate) // ensure numeric
      }));

      console.log("RebateRebate rsData:", this.rsData);

      // if (!rsData || rsData.length === 0) {
      //   return  <NoRecords component="instant-rebate" />;
      // }

      const columns = [
        { text: t("instant-rebate.rebate-date"), dataField: "update_date" },
        { text: t("instant-rebate.category"), dataField: "category" },
        { text: t("instant-rebate.provider"), dataField: "game_provider" },
        { text: t("instant-rebate.valid-bet"), dataField: "turnover" },
        { text: t("instant-rebate.rebate-rate"), dataField: "rebate_rate" },
        { text: t("instant-rebate.rebate-earned"), dataField: "instant_rebate" },
      ];

        return (
            <Auxiliary>
               <Fade duration={1000} triggerOnce>
                  <DataTable
                      keyField="no"
                      data={rsData}
                      columns={columns}
                      activePage={this.props.pagination?.current_page || 1}
                      limit={this.props.pagination?.per_page || 10}
                      totalItems={this.props.pagination?.total_record || 0}
                      paginationHandler={(val) => this.props.datatablesChangeHandler(val, this.props.tabName, "activePage")}
                      sizePerPageHandler={(val) => this.props.datatablesChangeHandler(val, this.props.tabName, "limit")}
                      loading={false}
                      hideSearchBar={true}
                      hideTotalRecords={true}
                      classValue="pd-table"
                      component="instant-rebate"
                  />
               </Fade>
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
  console.log("Redux state:", state);
  const rebateState = state.instantRebate || {};
  const rs = rebateState.rs || {};
  const rebateData = rs.data || {};             

  const rawTotal = rebateData.total?.totalTurnover;
  const totalRebate =
    typeof rawTotal === 'string' ? parseFloat(rawTotal) :
    (Number.isFinite(rawTotal) ? rawTotal : 0);

  return {
    rows: rebateData.result?.row || [],
    totalRebate,
    totalRecords: rebateData.total?.totalCount || 0,
    pagination: rebateData.result?.pagination || {},
  };
};


const mapDispatchToProps = (dispatch) => {
    return {
      getList: (props = {}) => dispatch(getList(props)),
      //getTotalInstantRebate: (props = {}) => dispatch(getTotalInstantRebate(props)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(Rebate));
